import { brighten, opacify } from "utils"

export const docketTheme = {
  colors: {
    background: "#fff",
    body: "#333",
    boxShadow: {
      dark: "rgba(43, 43, 43, 0.5)",
      normal: "rgba(183, 183, 183, 0.5)",
    },
    error: {
      normal: "#e72501",
    },
    grey: {
      normal: "#000",
      40: "#777777", // Should be fazed out
      60: "#999999", // Should be fazed out
      70: "#b2b2b2",
      80: "#cccccc",
      90: "#e5e5e5",
      95: "#f2f2f2",
    },
    info: "#51abff",
    link: {
      dark: "#1566b3",
      normal: "#1e92ff",
    },
    primary: {
      dark: "#393055",
      editable: "",
      hover: "",
      light: "",
      normal: "#595386",
    },
    secondary: {
      dark: "",
      disabled: "rgba(25,132,122,0.2)",
      hover: "",
      light: "",
      normal: "#198479",
    },

    success: "#008900",
    warning: {
      light: "#ffd859",
      normal: "#ffb723",
    },
    white: "#fff",
    black: "#000",
  },
  typography: {
    fontFamilySansSerif: "'Roboto', sans-serif",
    fontSize: "1.4rem",
    fontSize_h1: "3",
    fontSize_h2: "2.4rem",
    fontSize_h3: "2rem",
    fontSize_h4: "1.6rem",
    fontSize_h5: "1.28rem",
    fontSize_h6: "1.28rem",
    fontSize_md: "1.2rem",
    fontSize_sm: "1.024rem",
    fontWeight: 400,
    fontWeight_h2: 500,
    fontWeight_h4: 700,
    lineHeight: 1.5,
  },
}

docketTheme.colors.primary.editable = opacify(docketTheme.colors.primary.normal, 0.1)
docketTheme.colors.primary.light = opacify(docketTheme.colors.primary.normal, 0.2)
docketTheme.colors.primary.hover = brighten(docketTheme.colors.primary.normal, -20)
docketTheme.colors.secondary.dark = brighten(docketTheme.colors.secondary.normal, -20)
docketTheme.colors.secondary.light = opacify(docketTheme.colors.secondary.normal, 0.2)
docketTheme.colors.secondary.hover = brighten(docketTheme.colors.secondary.normal, -20)
